module.exports = __webpack_public_path__ + "img/5.c5c1fdc6.png";